/* eslint-disable react/prop-types,no-unused-vars */
import React from 'react';
import * as _ from 'lodash';
import {
  stepPersonalItemsExpenseLookup,
  stepOverseasMedicalExpenseLookup,
  stepCancellationAdditionalExpenseLookup,
  stepOtherExpenseLookup,
  stepRentalVehicleExpenseLookup,
  stepTripCancellationAndTripInterruptionExpenseLookup,
  stepBaggageAndPersonalItemsExpenseLookup,
  stepMedicalExpensesExpenseLookup,
  stepPetMedicalExpenseLookup,
  stepCollisionDamageExpenseLookup,
  stepPropertyDamageExpenseLookup,
  stepMedicalExpenseLookup,
  stepTripCancellationLookup,
  stepTripInterruptionLookup,
  stepTripDelayLookup,
  stepMissedConnectionLookup,
  stepBaggageAndPersonalLookup,
  stepMedicalExpenseCFLookup,
  baggagePersonalEffectsLookup,
  itineraryChangeLookup,
  stepTravelDelayLookup,
  stepMedicalAndEvacuationLookup,
  stepChangesToYourJourneyLookup,
  stepBaggageAndPersonalItemsSCTILookup,
  stepPersonalAccidentSCTILookup,
  stepRentalVehicleExcessSCTILookup,
  stepCashBankCardsTravelDocumentsAndPassportsLookup,
  stepChangesToYourJourneyTrawickLookup,
  stepBaggageAndPersonalItemsStarrLookup,
  stepOtherStarrLookup,
  stepCollisionDamageStarrLookup,
  stepMedicalExpensesTugoLookup,
  stepTripCancellationTugoLookup,
  stepOtherTugoLookup,
  stepBaseVictorsMedicalTugoLookup,
  stepStudentMedicalBenefitsTugoLookup,
  stepTripInterruptionTugoLookup,
  stepStandardVTCMedicalBenefitsTugoLookup,
  stepADAndDTugoLookup,
} from '../../../dataMapper/claimCodeMapper';
import stepOtherExpenseMapper from '../../../dataMapper/stepOtherDataMapper';
import stepTripCancellationAndTripInterruptionExpenseMapper from '../../../dataMapper/stepTripCancellationAndTripInterruption';
import stepBaggageAndPersonalItemsExpenseMapper from '../../../dataMapper/stepBaggageAndPersonalItemsDataMapper';
import stepMedicalExpensesExpenseMapper from '../../../dataMapper/stepMedicalExpensesDataMapper';
import stepMedicalExpenseMapper from '../../../dataMapper/stepMedicalExpenseDataMapper';
import stepTripCancellationMapper from '../../../dataMapper/stepTripCancellationDataMapper';
import stepTripDelayDataMapper from '../../../dataMapper/stepTripDelayDataMapper';
import stepTripInterruptionDataMapper from '../../../dataMapper/stepTripInterruptionDataMapper';
import stepPetMedicalMapper from '../../../dataMapper/stepPetMedicalDataMapper';
import stepCollisionDamageDataMapper from '../../../dataMapper/stepCollisionDamageDataMapper';
import stepPropertyDamageDataMapper from '../../../dataMapper/stepPropertyDamageDataMapper';
import stepMissedConnectionDataMapper from '../../../dataMapper/stepMissedConnectionDataMapper';
import stepPersonalItemDataMapper from '../../../dataMapper/stepPersonalItemDataMapper';
import stepMedicalExpenseCFDataMapper from '../../../dataMapper/stepMedicalExpenseCFDataMapper';
import stepMedicalExpenseZurichDataMapper from '../../../dataMapper/stepMedicalExpenseZurichDataMapper';
import stepItineraryChangeDataMapper from '../../../dataMapper/stepItineraryChangeDataMapper';
import stepBaggagePersonalEffectsDataMapper from '../../../dataMapper/stepBaggagePersonalEffectsDataMapper';
import stepTravelDelayDataMapper from '../../../dataMapper/stepTravelDelayDataMapper';
import stepMedicalAndEvacuationSCTIDataMapper from '../../../dataMapper/stepMedicalAndEvacuationSCTIDataMapper';
import stepChangesToYourJourneySCTIDataMapper from '../../../dataMapper/stepChangesToYourJourneySCTIDataMapper';
import stepBaggageAndPersonalItemsSCTIDataMapper from '../../../dataMapper/stepBaggageAndPersonalItemsSCTIDataMapper';
import stepCashBankCardsTravelDocumentsAndPassportsDataMapper from '../../../dataMapper/stepCashBankCardsTravelDocumentsAndPassportsDataMapper';
import stepPersonalAccidentSCTIDataMapper from '../../../dataMapper/stepPersonalAccidentSCTIDataMapper';
import stepRentalVehicleExcessSCTIDataMapper from '../../../dataMapper/stepRentalVehicleExcessSCTIDataMapper';
import stepChangesToYourJourneyDataMapper from '../../../dataMapper/stepChangesToYourJourneyDataMapper';
import stepBaggageAndPersonalItemsStarrDataMapper from '../../../dataMapper/stepBaggageAndPersonalItemsStarrDataMapper';
import stepOtherStarrDataMapper from '../../../dataMapper/stepOtherDataStarrMapper';
import stepCollisionDamageStarrDataMapper from '../../../dataMapper/stepCollisionDamageStarrDataMapper';
import stepMedicalExpensesTugoDataMapper from '../../../dataMapper/stepMedicalExpensesTugoDataMapper';
import stepOtherTugoDataMapper from '../../../dataMapper/stepOtherDataTugoMapper';
import stepBaseVictorsMedicalTugoDataMapper from '../../../dataMapper/stepBaseVictorsMedicalTugoDataMapper';
import stepStudentMedicalBenefitsTugoDataMapper from '../../../dataMapper/stepStudentMedicalBenefitsTugoDataMapper';
import stepStandardVTCMedicalBenefitsTugoDataMapper from '../../../dataMapper/stepStandardVTCMedicalBenefitsTugoDataMapper';
import stepTripCancellationTugoDataMapper from '../../../dataMapper/stepTripCancellationTugoDataMapper';
import stepTripInterruptionTugoDataMapper from '../../../dataMapper/stepTripInterruptionTugoDataMapper';
import stepADAndDTugoDataMapper from '../../../dataMapper/stepADAndDTugoDataMapper';
import { Table } from '../../../../../components/Table';
import TH from '../../../../../components/Table/TH';
import TR from '../../../../../components/Table/TR';
import TD from '../../../../../components/Table/TD';
import messages from './messages';
import { FormattedMessage } from 'react-intl';


const DocumentTable = (props) => {
  const renderIcon = (hasFile) => {
    if (hasFile) {
      return <i style={{ color: '#44b4a6' }} className="fa fa-check fa-2x" aria-hidden="true" />;
    }
    return <i style={{ color: 'red' }} className="fa fa-times fa-2x" aria-hidden="true" />;
  };

  const checkProvided = (claimCodeList) => {
    const listDocuments = props.listDocuments || [];
    const attachDocuments = (props.stepSupportingDocumentsData && props.stepSupportingDocumentsData.attachDocuments) || [];
    // Find all items in listDocuments that match any of our codes OR have a parent in our codes
    let relevantItems = listDocuments.filter(item =>
      claimCodeList.includes(item.claimCode) || claimCodeList.includes(item.parentBenefitCode)
    );

    // If no relevant items found via direct claim code, check if there's a match via description 
    // (useful for TuGo VTC where codes might be grouped under a parent)
    if (relevantItems.length === 0) {
      relevantItems = listDocuments.filter(item => 
        claimCodeList.some(code => code && item.claimCode && (code.includes(item.claimCode) || item.claimCode.includes(code)))
      );
    }

    if (relevantItems.length === 0) {
      // Fallback: check if ANY document is attached for any of the codes (standard logic)
      return claimCodeList.some(code =>
        attachDocuments.some(doc => doc.benefitCode === code)
      );
    }

    let allMandatoryProvided = true;
    let anyMandatoryExists = false;

    relevantItems.forEach(item => {
      const requiredDocs = item.requiredDocuments || [];
      const mandatoryDocs = requiredDocs.filter(d => d.mandatory);

      if (mandatoryDocs.length > 0) {
        anyMandatoryExists = true;
        const allProvided = mandatoryDocs.every(m =>
          attachDocuments.some(doc => doc.requiredDocumentId === m.claimRequiredDocumentId)
        );
        if (!allProvided) {
          allMandatoryProvided = false;
        }
      }
    });

    if (anyMandatoryExists) {
      return allMandatoryProvided;
    }

    // If no mandatory docs defined, check if ANY document is provided for these items
    return relevantItems.some(item =>
      attachDocuments.some(doc => doc.benefitCode === item.claimCode)
    ) || claimCodeList.some(code => attachDocuments.some(doc => doc.benefitCode === code));
  };
  const { selectedBenefits } = props.stepWhatHappenedData;
  const { attachDocuments, warningMissingRequiredDocument } = props.stepSupportingDocumentsData;
  const { medicalExpenses } = props.stepOverseasMedicalData;
  const { lossInformationItems } = props.stepTripCancellationAndTripInterruptionData;
  const { descriptionOfItems, descriptionOfItemsForDamaged } = props.stepBaggageAndPersonalItemsData;
  const { additionalItems, delayedLuggageExpenses } = props.stepPersonalItemsData;
  // const stepMedicalExpensesData = props.stepMedicalExpensesData;
  const { cancellationExpenses, delayedTravelExpenses, additionalExpenses } = props.stepCancellationAdditionalData;
  const { bicyclePackOptionalExpensesClaimed, golfPackOptionalExpensesClaimed,
    personalLiabilitiesExpensesClaimed, areYouClaimingForPersonalLiability, anythingElseExpensesClaimed, isThereAnyThingElseYouWouldLikeToClaimFor,
    areYouClaimingForGolfPackOptionalCover, areYouClaimingForBicyclePackOptionalCover, areYouClaimingForAccidentalDeathAndDismemberment,
    areYouClaimingForBurialOrRepatriationExpenses, checkNameOfDeceases, causeOfDeath, amountClaimed } = props.stepOtherData;
  let stepOverseasMedicalAmount = 0;
  let stepPersonalItemsAmount = 0;
  let stepCancellationAdditionalAmount = 0;
  let stepTripCancellationAndTripInterruptionAmount = 0;
  let stepBaggageAndPersonalItemsAmount = 0;
  const stepRentalVehicleAmount = props.stepRentalVehicleData ? +props.stepRentalVehicleData.amountClaimed : 0;
  let stepOtherAmount = 0;
  let sum = 0;
  const list = (!!selectedBenefits && typeof selectedBenefits.toJS === 'function') ? selectedBenefits.toJS() : (selectedBenefits || []);
  const isStepPersonalItemsSelected = (list.filter((d) => ((stepPersonalItemsExpenseLookup.claimCodeList).filter((c) => c === d.claimCode || c === d.parentBenefitCode)).length > 0)).length > 0;
  const isStepOverseasMedicalSelected = (list.filter((d) => ((stepOverseasMedicalExpenseLookup.claimCodeList).filter((c) => c === d.claimCode || c === d.parentBenefitCode)).length > 0)).length > 0;
  const isStepOtherSelected = (list.filter((d) => ((stepOtherExpenseLookup.claimCodeList).filter((c) => c === d.claimCode || c === d.parentBenefitCode)).length > 0)).length > 0;
  const isStepCancellationAdditionalSelected = (list.filter((d) => ((stepCancellationAdditionalExpenseLookup.claimCodeList).filter((c) => c === d.claimCode || c === d.parentBenefitCode)).length > 0)).length > 0;
  const isStepRentalVehicleSelected = (list.filter((d) => ((stepRentalVehicleExpenseLookup.claimCodeList).filter((c) => c === d.claimCode || c === d.parentBenefitCode)).length > 0)).length > 0;
  const isStepTripCancellationAndTripInterruptionSelected = (list.filter((d) => ((stepTripCancellationAndTripInterruptionExpenseLookup.claimCodeList).filter((c) => c === d.claimCode || c === d.parentBenefitCode)).length > 0)).length > 0;
  const isStepBaggageAndPersonalItemsSelected = (list.filter((d) => ((stepBaggageAndPersonalItemsExpenseLookup.claimCodeList).filter((c) => c === d.claimCode || c === d.parentBenefitCode)).length > 0)).length > 0;
  const isStepMedicalExpensesSelected = !props.showZurichUHC && (list.filter((d) => ((stepMedicalExpensesExpenseLookup.claimCodeList).filter((c) => c === d.claimCode || c === d.parentBenefitCode)).length > 0)).length > 0;
  const isStepCollisionDamageSelected = (list.filter((d) => ((stepCollisionDamageExpenseLookup.claimCodeList).filter((c) => c === d.claimCode || c === d.parentBenefitCode)).length > 0)).length > 0;
  const isStepPetMedicalSelected = (list.filter((d) => ((stepPetMedicalExpenseLookup.claimCodeList).filter((c) => c === d.claimCode || c === d.parentBenefitCode)).length > 0)).length > 0;
  const isStepPropertyDamageSelected = (list.filter((d) => ((stepPropertyDamageExpenseLookup.claimCodeList).filter((c) => c === d.claimCode || c === d.parentBenefitCode)).length > 0)).length > 0;
  const isStepTripCancellationSelected = (list.filter((d) => ((stepTripCancellationLookup.claimCodeList).filter((c) => c === d.claimCode || c === d.parentBenefitCode)).length > 0)).length > 0;
  const isStepMedicalExpenseSelected = (list.filter((d) => ((stepMedicalExpenseLookup.claimCodeList).filter((c) => c === d.claimCode || c === d.parentBenefitCode)).length > 0)).length > 0;
  const isStepTripInterruptionSelected = (list.filter((d) => ((stepTripInterruptionLookup.claimCodeList).filter((c) => c === d.claimCode || c === d.parentBenefitCode)).length > 0)).length > 0;
  const isStepTripDelaySelected = (list.filter((d) => ((stepTripDelayLookup.claimCodeList).filter((c) => c === d.claimCode || c === d.parentBenefitCode)).length > 0)).length > 0;
  const isStepMissedConnectionSelected = (list.filter((d) => ((stepMissedConnectionLookup.claimCodeList).filter((c) => c === d.claimCode || c === d.parentBenefitCode)).length > 0)).length > 0;
  const isStepPersonalItemSelected = (list.filter((d) => ((stepBaggageAndPersonalLookup.claimCodeList).filter((c) => c === d.claimCode || c === d.parentBenefitCode)).length > 0)).length > 0;
  const isStepMedicalExpenseCFSelected = (list.filter((d) => ((stepMedicalExpenseCFLookup.claimCodeList).filter((c) => c === d.claimCode || c === d.parentBenefitCode)).length > 0)).length > 0;
  const isStepMedicalExpenseZurichSelected = props.showZurichUHC && (list.filter((d) => ((stepMedicalExpensesExpenseLookup.claimCodeList).filter((c) => c === d.claimCode || c === d.parentBenefitCode)).length > 0)).length > 0;
  const isStepItineraryChangeSelected = (list.filter((d) => ((itineraryChangeLookup.claimCodeList).filter((c) => c === d.claimCode || c === d.parentBenefitCode)).length > 0)).length > 0;
  const isStepBaggagePersonalEffectsSelected = (list.filter((d) => ((baggagePersonalEffectsLookup.claimCodeList).filter((c) => c === d.claimCode || c === d.parentBenefitCode)).length > 0)).length > 0;
  const isStepTravelDelaySelected = (list.filter((d) => ((stepTravelDelayLookup.claimCodeList).filter((c) => c === d.claimCode || c === d.parentBenefitCode)).length > 0)).length > 0;
  const isStepMedicalAndEvacuationSelected = (list.filter((d) => ((stepMedicalAndEvacuationLookup.claimCodeList).filter((c) => c === d.claimCode || c === d.parentBenefitCode)).length > 0)).length > 0;
  const isStepChangesToYourJourneySCTISelected = (list.filter((d) => ((stepChangesToYourJourneyLookup.claimCodeList).filter((c) => c === d.claimCode || c === d.parentBenefitCode)).length > 0)).length > 0;
  const isStepBaggageAndPersonalItemsSCTISelected = (list.filter((d) => ((stepBaggageAndPersonalItemsSCTILookup.claimCodeList).filter((c) => c === d.claimCode || c === d.parentBenefitCode)).length > 0)).length > 0;
  const isStepCashBankCardsTravelDocumentsAndPassportsSelected = (list.filter((d) => ((stepCashBankCardsTravelDocumentsAndPassportsLookup.claimCodeList).filter((c) => c === d.claimCode || c === d.parentBenefitCode)).length > 0)).length > 0;
  const isStepPersonalAccidentSCTISelected = (list.filter((d) => ((stepPersonalAccidentSCTILookup.claimCodeList).filter((c) => c === d.claimCode || c === d.parentBenefitCode)).length > 0)).length > 0;
  const isStepRentalVehicleExcessSCTISelected = (list.filter((d) => ((stepRentalVehicleExcessSCTILookup.claimCodeList).filter((c) => c === d.claimCode || c === d.parentBenefitCode)).length > 0)).length > 0;
  const isStepChangesToYourJourneySelected = (list.filter((d) => ((stepChangesToYourJourneyTrawickLookup.claimCodeList).filter((c) => c === d.claimCode || c === d.parentBenefitCode)).length > 0)).length > 0;
  const isStepBaggageAndPersonalItemsStarrSelected = (list.filter((d) => ((stepBaggageAndPersonalItemsStarrLookup.claimCodeList).filter((c) => c === d.claimCode || c === d.parentBenefitCode)).length > 0)).length > 0;
  const isStepOtherStarrSelected = (list.filter((d) => ((stepOtherStarrLookup.claimCodeList).filter((c) => c === d.claimCode || c === d.parentBenefitCode)).length > 0)).length > 0;
  const isStepCollisionDamageStarrSelected = (list.filter((d) => ((stepCollisionDamageStarrLookup.claimCodeList).filter((c) => c === d.claimCode || c === d.parentBenefitCode)).length > 0)).length > 0;

  const isStepMedicalExpensesTugoSelected = list.some((d) => stepMedicalExpensesTugoLookup.claimCodeList.includes(d.claimCode) || stepMedicalExpensesTugoLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepOtherTugoSelected = list.some((d) => stepOtherTugoLookup.claimCodeList.includes(d.claimCode) || stepOtherTugoLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepBaseVictorsMedicalTugoSelected = list.some((d) => stepBaseVictorsMedicalTugoLookup.claimCodeList.includes(d.claimCode) || stepBaseVictorsMedicalTugoLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepStudentMedicalBenefitsTugoSelected = list.some((d) => stepStudentMedicalBenefitsTugoLookup.claimCodeList.includes(d.claimCode) || stepStudentMedicalBenefitsTugoLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepStandardVTCMedicalBenefitsTugoSelected = list.some((d) => stepStandardVTCMedicalBenefitsTugoLookup.claimCodeList.includes(d.claimCode) || stepStandardVTCMedicalBenefitsTugoLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepTripCancellationTugoSelected = list.some((d) => stepTripCancellationTugoLookup.claimCodeList.includes(d.claimCode) || stepTripCancellationTugoLookup.claimCodeList.includes(d.parentBenefitCode));

  const hasEmbeddedTIExpenses = isStepTripCancellationTugoSelected
    && stepTripInterruptionTugoDataMapper.mapToExpenses(props.stepTripInterruptionTugoData || {}).length > 0;

  const isStepTripInterruptionTugoSelected = list.some((d) => stepTripInterruptionTugoLookup.claimCodeList.includes(d.claimCode) || stepTripInterruptionTugoLookup.claimCodeList.includes(d.parentBenefitCode))
    || hasEmbeddedTIExpenses;

  const isStepADAndDTugoSelected = list.some((d) => stepADAndDTugoLookup.claimCodeList.includes(d.claimCode) || stepADAndDTugoLookup.claimCodeList.includes(d.parentBenefitCode));
  if (isStepCancellationAdditionalSelected && cancellationExpenses.length) {
    stepCancellationAdditionalAmount += _.sumBy(cancellationExpenses, (o) => +o.prePaidAmount);
  }
  if (isStepCancellationAdditionalSelected && delayedTravelExpenses.length) {
    stepCancellationAdditionalAmount += _.sumBy(delayedTravelExpenses, (o) => +o.amount);
  }

  if (isStepPersonalItemsSelected && additionalItems && additionalItems.length > 0) {
    stepPersonalItemsAmount += _.sumBy(additionalItems, (o) => +o.amountClaimed);
  }
  if (isStepPersonalItemsSelected && delayedLuggageExpenses && delayedLuggageExpenses.length > 0) {
    stepPersonalItemsAmount += _.sumBy(delayedLuggageExpenses, (o) => +o.amountClaimed);
  }

  if (isStepOverseasMedicalSelected && medicalExpenses && medicalExpenses.length > 0) {
    stepOverseasMedicalAmount = _.sumBy(medicalExpenses, (o) => +o.amountCharged);
  }
  if (areYouClaimingForBicyclePackOptionalCover === 'true' && bicyclePackOptionalExpensesClaimed.length) {
    stepOtherAmount += _.sumBy(bicyclePackOptionalExpensesClaimed, (o) => +o.amount);
  }
  if (areYouClaimingForGolfPackOptionalCover === 'true' && golfPackOptionalExpensesClaimed.length) {
    stepOtherAmount += _.sumBy(golfPackOptionalExpensesClaimed, (o) => +o.amount);
  }
  if (areYouClaimingForPersonalLiability === 'true' && personalLiabilitiesExpensesClaimed.length) {
    stepOtherAmount += _.sumBy(personalLiabilitiesExpensesClaimed, (o) => +o.amount);
  }
  if (isThereAnyThingElseYouWouldLikeToClaimFor === 'true' && anythingElseExpensesClaimed.length) {
    stepOtherAmount += _.sumBy(anythingElseExpensesClaimed, (o) => +o.amount);
  }
  if (areYouClaimingForAccidentalDeathAndDismemberment === 'true' && !!checkNameOfDeceases) {
    stepOtherAmount += 0;
  }
  if (areYouClaimingForBurialOrRepatriationExpenses === 'true' && !!causeOfDeath) {
    stepOtherAmount += amountClaimed;
  }

  if (isStepTripCancellationAndTripInterruptionSelected && lossInformationItems.length) {
    stepTripCancellationAndTripInterruptionAmount += _.sumBy(lossInformationItems, (o) => +o.amountPaidLoss);
  }

  if (isStepBaggageAndPersonalItemsSelected && descriptionOfItems.length) {
    stepBaggageAndPersonalItemsAmount += _.sumBy(descriptionOfItems, (o) => +o.howMuch);
  }

  if (isStepBaggageAndPersonalItemsSelected && descriptionOfItemsForDamaged.length) {
    stepBaggageAndPersonalItemsAmount += _.sumBy(descriptionOfItemsForDamaged, (o) => +o.howMuch);
  }

  sum = stepCancellationAdditionalAmount + stepPersonalItemsAmount + stepOverseasMedicalAmount + stepRentalVehicleAmount + stepOtherAmount + stepTripCancellationAndTripInterruptionAmount + stepBaggageAndPersonalItemsAmount;
  const renderStepOverseasMedical = () => (
    medicalExpenses.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={medicalExpenses.length}>Medical</TD>}
        <TD className={`${idx === medicalExpenses.length - 1 ? 'document-table-bottom document-table-right align-middle' : 'align-middle document-table-right'}`}>{x.nameOfDoctorOrProvider} | {x.treatmentReceived}</TD>
        <TD className={`${idx === medicalExpenses.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.amountCharged ? (+x.amountCharged).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === medicalExpenses.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={medicalExpenses.length} > {renderIcon(checkProvided(stepOverseasMedicalExpenseLookup.claimCodeList))}</TD>}
      </TR>
    ))
  );

  const renderStepPersonalItems = () => {
    const data = additionalItems.concat(delayedLuggageExpenses);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>Personal Items</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.descriptionOfItem}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.amountClaimed ? (+x.amountClaimed).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.amountClaimedCurrency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepPersonalItemsExpenseLookup.claimCodeList))}</TD>}
      </TR>
    ));
  };

  const renderStepCancellationAdditional = () => {
    const additionalMapper = additionalExpenses.map((x) => ({
      description: `${x.supplier} | ${x.description}`,
      amount: x.amountPaid,
      currency: x.amountPaidCurrency,
    }));
    const delayedTravelExpensesMapper = delayedTravelExpenses.map((x) => ({
      description: x.description,
      amount: x.amount,
      currency: x.amountCurrency,
    }));

    const cancellationExpensesMapper = cancellationExpenses.map((x) => ({
      description: `${x.supplier} | ${x.cancelledBookingDescription}`,
      amount: x.prePaidAmount,
      currency: x.prePaidAmountCurrency,
    }));
    const data = additionalMapper.concat(delayedTravelExpensesMapper, cancellationExpensesMapper);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>Trip Interruption and Travel Delay</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.description}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.amount ? (+x.amount).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepCancellationAdditionalExpenseLookup.claimCodeList))}</TD>}
      </TR>
    ));
  };

  const renderStepOther = () => {
    const data = stepOtherExpenseMapper.mapToExpenses(props.stepOtherData);

    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-top document-table-left document-table-right" rowSpan={data.length}>Other</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.shortDescription}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-top document-table-right" rowSpan={data.length}> {renderIcon(checkProvided(stepOtherExpenseLookup.claimCodeList))}</TD>}
      </TR>
    ));
  };


  const renderStepTripCancellationAndTripInterruption = () => {
    const data = stepTripCancellationAndTripInterruptionExpenseMapper.mapToExpenses(props.stepTripCancellationAndTripInterruptionData);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>Trip Cancellation & Trip Interruption</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.shortDescription}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepTripCancellationAndTripInterruptionExpenseLookup.claimCodeList))}</TD>}
      </TR>
    ));
  };

  const renderStepBaggageAndPersonalItems = () => {
    const data = stepBaggageAndPersonalItemsExpenseMapper.mapToExpenses(props.stepBaggageAndPersonalItemsData);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>Baggage and Personal Items</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.shortDescription}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepBaggageAndPersonalItemsExpenseLookup.claimCodeList))}</TD>}
      </TR>
    ));
  };

  const renderStepMedicalExpenses = () => {
    const data = stepMedicalExpensesExpenseMapper.mapToExpenses(props.stepMedicalExpensesData);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>Medical Expenses</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.shortDescription}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepMedicalExpensesExpenseLookup.claimCodeList))}</TD>}
      </TR>
    ));
  };

  const renderStepCollisionDamage = () => {
    const data = stepCollisionDamageDataMapper.mapToExpenses(props.stepCollisionDamageData);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>Collision Damage</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.shortDescription}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepCollisionDamageExpenseLookup.claimCodeList))}</TD>}
      </TR>
    ));
  };

  const renderStepPetMedical = () => {
    const data = stepPetMedicalMapper.mapToExpenses(props.stepPetMedicalData);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>Pet Medical</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.shortDescription}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD style={{ textAlign: 'center' }} className="document-table-right document-table-bottom">{renderIcon(checkProvided(stepPetMedicalExpenseLookup.claimCodeList))}</TD>}
      </TR>
    ));
  };

  const renderStepPropertyDamage = () => {
    const data = stepPropertyDamageDataMapper.mapToExpenses(props.stepPropertyDamageData);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>Property Damage</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.shortDescription}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD style={{ textAlign: 'center' }} className="document-table-right document-table-bottom">{renderIcon(checkProvided(stepPropertyDamageExpenseLookup.claimCodeList))}</TD>}
      </TR>
    ));
  };

  const renderStepTripCancellation = () => {
    const data = stepTripCancellationMapper.mapToExpenses(props.stepTripCancellationData);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>Trip Cancellation</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.shortDescription}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD style={{ textAlign: 'center' }} className="document-table-right document-table-bottom">{renderIcon(checkProvided(stepTripCancellationLookup.claimCodeList))}</TD>}
      </TR>
    ));
  };

  const renderMedicalExpense = () => {
    const data = stepMedicalExpenseMapper.mapToExpenses(props.stepMedicalExpenseData);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>Medical Expense</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.shortDescription}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepMedicalExpenseLookup.claimCodeList))}</TD>}
      </TR>
    ));
  };

  const renderTripInterruption = () => {
    const data = stepTripInterruptionDataMapper.mapToExpenses(props.stepTripInterruptionData);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>Trip Interruption</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.shortDescription}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD style={{ textAlign: 'center' }} className="document-table-right document-table-bottom">{renderIcon(checkProvided(stepTripInterruptionLookup.claimCodeList))}</TD>}
      </TR>
    ));
  };

  const renderTripDelay = () => {
    const data = stepTripDelayDataMapper.mapToExpenses(props.stepTripDelayData);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>Trip Delay</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.shortDescription}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD style={{ textAlign: 'center' }} className="document-table-right document-table-bottom">{renderIcon(checkProvided(stepTripDelayLookup.claimCodeList))}</TD>}
      </TR>
    ));
  };

  const renderMissedConnection = () => {
    const data = stepMissedConnectionDataMapper.mapToExpenses(props.stepMissedConnectionData);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>Missed Connection</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.shortDescription}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD style={{ textAlign: 'center' }} className="document-table-right document-table-bottom">{renderIcon(checkProvided(stepMissedConnectionLookup.claimCodeList))}</TD>}
      </TR>
    ));
  };

  const renderPersonalItem = () => {
    const data = stepPersonalItemDataMapper.mapToExpenses(props.stepPersonalItemData);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>Baggage and Personal Effects</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.shortDescription}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepBaggageAndPersonalLookup.claimCodeList))}</TD>}
      </TR>
    ));
  };

  const renderMedicalExpenseCF = () => {
    const data = stepMedicalExpenseCFDataMapper.mapToExpenses(props.stepMedicalExpenseCFData);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>Medical Expense</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.shortDescription}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepMedicalExpenseCFLookup.claimCodeList))}</TD>}
      </TR>
    ));
  };

  const renderMedicalExpenseZurich = () => {
    const data = stepMedicalExpenseZurichDataMapper.mapToExpenses(props.stepMedicalExpenseZurichData);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>Medical Expense</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.shortDescription}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepMedicalExpensesExpenseLookup.claimCodeList))}</TD>}
      </TR>
    ));
  };

  const renderItineraryChange = () => {
    const data = stepItineraryChangeDataMapper.mapToExpenses(props.stepItineraryChangeData);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>Itinerary Change</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.shortDescription}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(itineraryChangeLookup.claimCodeList))}</TD>}
      </TR>
    ));
  };

  const renderBaggagePersonalEffects = () => {
    const data = stepBaggagePersonalEffectsDataMapper.mapToExpenses(props.stepBaggagePersonalEffectsData);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>Baggage Personal Effects</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.shortDescription}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(baggagePersonalEffectsLookup.claimCodeList))}</TD>}
      </TR>
    ));
  };

  const renderStepTravelDelay = () => {
    const data = stepTravelDelayDataMapper.mapToExpenses(props.stepTravelDelayData);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>Travel Delay & Missed Connections</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.shortDescription}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD style={{ textAlign: 'center' }} className="document-table-right document-table-bottom">{renderIcon(checkProvided(stepTravelDelayLookup.claimCodeList))}</TD>}
      </TR>
    ));
  };

  const renderMedicalAndEvacuation = () => {
    const data = stepMedicalAndEvacuationSCTIDataMapper.mapToExpenses(props.stepMedicalAndEvacuationSCTIData);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>Medical and Evacuation</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.shortDescription}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepMedicalAndEvacuationLookup.claimCodeList))}</TD>}
      </TR>
    ));
  };

  const renderChangesToYourJourneySCTI = () => {
    const data = stepChangesToYourJourneySCTIDataMapper.mapToExpenses(props.stepChangesToYourJourneySCTIData);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>Changes to your journey</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.shortDescription}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepChangesToYourJourneyLookup.claimCodeList))}</TD>}
      </TR>
    ));
  };

  const renderBaggageAndPersonalItemsSCTI = () => {
    const data = stepBaggageAndPersonalItemsSCTIDataMapper.mapToExpenses(props.stepBaggageAndPersonalItemsSCTIData);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>Baggage and personal items</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.shortDescription}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepBaggageAndPersonalLookup.claimCodeList))}</TD>}
      </TR>
    ));
  };

  const renderPersonalAccidentSCTI = () => {
    const data = stepPersonalAccidentSCTIDataMapper.mapToExpenses(props.stepPersonalAccidentSCTIData);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>Personal Accident</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.shortDescription}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepPersonalAccidentSCTILookup.claimCodeList))}</TD>}
      </TR>
    ));
  };

  const renderRentalVehicleExcessSCTI = () => {
    const data = stepRentalVehicleExcessSCTIDataMapper.mapToExpenses(props.stepRentalVehicleExcessSCTIData);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>Rental vehicle excess</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.shortDescription}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepRentalVehicleExcessSCTILookup.claimCodeList))}</TD>}
      </TR>
    ));
  };

  const renderCashBankCardsTravelDocumentsAndPassports = () => {
    const data = stepCashBankCardsTravelDocumentsAndPassportsDataMapper.mapToExpenses(props.stepCashBankCardsTravelDocumentsAndPassportsData);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>Cash, bank cards, travel documents and passports</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.shortDescription}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepCashBankCardsTravelDocumentsAndPassportsLookup.claimCodeList))}</TD>}
      </TR>
    ));
  };

  const renderChangesToYourJourney = () => {
    const data = stepChangesToYourJourneyDataMapper.mapToExpenses(props.stepChangesToYourJourneyData);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>Changes to your journey</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.shortDescription}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepChangesToYourJourneyTrawickLookup.claimCodeList))}</TD>}
      </TR>
    ));
  };

  const renderBaggageAndPersonalItemsStarr = () => {
    const data = stepBaggageAndPersonalItemsStarrDataMapper.mapToExpenses(props.stepBaggageAndPersonalItemsStarrData);

    const hasRequiredDocuments = attachDocuments
      .some((doc) => stepBaggageAndPersonalItemsStarrLookup.claimCodeList
        .includes(doc.benefitCode));

    const showCheckmark = hasRequiredDocuments &&
      isStepBaggageAndPersonalItemsStarrSelected &&
      warningMissingRequiredDocument === '';

    return data.map((item, idx) => {
      const isLastRow = idx === data.length - 1;
      const baseColumnClass = 'align-middle document-table-right';
      const lastRowClass = isLastRow ? 'document-table-bottom ' : '';

      return (
        <TR key={idx} noHover>
          {idx === 0 && (
            <TD
              className="align-middle document-table-left document-table-bottom document-table-right"
              rowSpan={data.length}
            >
              Baggage And Personal Items
            </TD>
          )}
          <TD className={`${lastRowClass}${baseColumnClass}`}>
            {item.shortDescription}
          </TD>
          <TD className={`${lastRowClass}${baseColumnClass} text-right`}>
            ${item.clientCost ? (+item.clientCost).toLocaleString('en') : 0}
          </TD>
          <TD className={`${lastRowClass}${baseColumnClass}`}>
            {item.currency}
          </TD>
          {idx === 0 && (
            <TD
              className="text-center align-middle document-table-right document-table-bottom"
              rowSpan={data.length}
            >
              {renderIcon(showCheckmark)}
            </TD>
          )}
        </TR>
      );
    });
  };

  const renderOtherStarr = () => {
    const data = stepOtherStarrDataMapper.mapToExpenses(props.stepOtherStarrData);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>Other</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.shortDescription}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepOtherStarrLookup.claimCodeList))}</TD>}
      </TR>
    ));
  };

  const renderCollisionDamageStarr = () => {
    const data = stepCollisionDamageStarrDataMapper.mapToExpenses(props.stepCollisionDamageStarrData);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>Collision Damage</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.shortDescription}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepCollisionDamageStarrLookup.claimCodeList))}</TD>}
      </TR>
    ));
  };

  const renderMedicalExpensesTugo = () => {
    const data = stepMedicalExpensesTugoDataMapper.mapToExpenses(props.stepMedicalExpensesTugoData);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>Medical Expenses</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.shortDescription}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepMedicalExpensesTugoLookup.claimCodeList))}</TD>}
      </TR>
    ));
  };

  const renderOtherTugo = () => {
    const data = stepOtherTugoDataMapper.mapToExpenses(props.stepOtherTugoData);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>Other</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.shortDescription}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepOtherTugoLookup.claimCodeList))}</TD>}
      </TR>
    ));
  }

  const renderBaseVictorsMedicalTugo = () => {
    const data = stepBaseVictorsMedicalTugoDataMapper.mapToExpenses(props.stepBaseVictorsMedicalTugoData);
    return renderExpenseRows(data, stepBaseVictorsMedicalTugoLookup, isStepBaseVictorsMedicalTugoSelected, 'Medical Expenses');
  };

  const renderStudentMedicalBenefitsTugo = () => {
    const data = stepStudentMedicalBenefitsTugoDataMapper.mapToExpenses(props.stepStudentMedicalBenefitsTugoData);
    return renderExpenseRows(data, stepStudentMedicalBenefitsTugoLookup, isStepStudentMedicalBenefitsTugoSelected, 'Student Medical Benefits');
  };

  const renderStandardVTCMedicalBenefitsTugo = () => {
    const data = stepStandardVTCMedicalBenefitsTugoDataMapper.mapToExpenses(props.stepStandardVTCMedicalBenefitsTugoData);
    const title = data.length > 0 ? (data[0].benefitTitle || 'Medical Benefits') : 'Medical Benefits';
    return renderExpenseRows(data, stepStandardVTCMedicalBenefitsTugoLookup, isStepStandardVTCMedicalBenefitsTugoSelected, title);
  };

  const renderTripInterruptionTugo = () => {
    const data = stepTripInterruptionTugoDataMapper.mapToExpenses(props.stepTripInterruptionTugoData);
    return renderExpenseRows(data, stepTripInterruptionTugoLookup, isStepTripInterruptionTugoSelected, 'Trip Interruption');
  };

  const renderTripCancellationTugo = () => {
    const data = stepTripCancellationTugoDataMapper.mapToExpenses(props.stepTripCancellationTugoData || {});
    return renderExpenseRows(data, stepTripCancellationTugoLookup, isStepTripCancellationTugoSelected, 'Trip Cancellation');
  };

  const renderADAndDTugo = () => {
    const data = stepADAndDTugoDataMapper.mapToExpenses(props.stepADAndDBenefitsTugoData || {});
    return renderExpenseRows(data, stepADAndDTugoLookup, isStepADAndDTugoSelected, 'AD&D');
  };

  const renderExpenseRows = (data, lookup, isSelected, title) => {
    if (!data || data.length === 0) return null;
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{title}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.shortDescription}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(lookup.claimCodeList))}</TD>}
      </TR>
    ));
  }

  return (
    <Table>
      <thead>
        <tr>
          <TH className="document-table-top document-table-left document-table-right align-middle" color={'#000000'} backgroundColor={'#fff'}>
            <FormattedMessage {...messages.Benefit} id={messages.Benefit.id} />
          </TH>
          <TH className="document-table-top document-table-right align-middle" color={'#000000'} backgroundColor={'#fff'}>
            <FormattedMessage {...messages.Description} id={messages.Description.id} />
          </TH>
          <TH className="text-right document-table-top document-table-right align-middle" color={'#000000'} backgroundColor={'#fff'}>
            <FormattedMessage {...messages.Amount} id={messages.Amount.id} />
          </TH>
          <TH className="document-table-top document-table-right align-middle" color={'#000000'} backgroundColor={'#fff'}>
            <FormattedMessage {...messages.currency} id={messages.currency.id} />
          </TH>
          <TH className="document-table-top document-table-right align-middle" color={'#000000'} backgroundColor={'#fff'}>
            <FormattedMessage {...messages.provided} id={messages.provided.id} />
          </TH>
        </tr>
      </thead>
      <tbody>
        {isStepOverseasMedicalSelected && renderStepOverseasMedical()}
        {isStepPersonalItemsSelected && renderStepPersonalItems()}
        {isStepCancellationAdditionalSelected && renderStepCancellationAdditional()}
        {isStepRentalVehicleSelected && !!stepRentalVehicleExpenseLookup.areYouClaimingForRentalVehicleExcess.claimCode && <TR noHover>
          <TD className="align-middle document-table-left  document-table-bottom document-table-right">Rental Vehicle</TD>
          <TD className="document-table-bottom align-middle document-table-right" >{props.stepRentalVehicleData.description}</TD>
          <TD className="document-table-bottom text-right align-middle  document-table-right">{(+stepRentalVehicleAmount).toLocaleString('en')}</TD>
          <TD className="document-table-bottom align-middle document-table-right">{props.stepRentalVehicleData.amountClaimedCurrency}</TD>
          <TD style={{ textAlign: 'center' }} className="document-table-right document-table-top"> {renderIcon(checkProvided(stepRentalVehicleExpenseLookup.claimCodeList))}</TD>
        </TR>}
        {isStepOtherSelected && renderStepOther()}
        {isStepTripCancellationAndTripInterruptionSelected && renderStepTripCancellationAndTripInterruption()}
        {isStepBaggageAndPersonalItemsSelected && renderStepBaggageAndPersonalItems()}
        {isStepMedicalExpensesSelected && renderStepMedicalExpenses()}
        {isStepCollisionDamageSelected && renderStepCollisionDamage()}
        {isStepPetMedicalSelected && renderStepPetMedical()}
        {isStepPropertyDamageSelected && renderStepPropertyDamage()}
        {isStepTripCancellationSelected && renderStepTripCancellation()}
        {isStepMedicalExpenseSelected && renderMedicalExpense()}
        {isStepTripInterruptionSelected && renderTripInterruption()}
        {isStepTripDelaySelected && renderTripDelay()}
        {isStepMissedConnectionSelected && renderMissedConnection()}
        {isStepPersonalItemSelected && renderPersonalItem()}
        {isStepMedicalExpenseCFSelected && renderMedicalExpenseCF()}
        {isStepMedicalExpenseZurichSelected && renderMedicalExpenseZurich()}
        {isStepItineraryChangeSelected && renderItineraryChange()}
        {isStepBaggagePersonalEffectsSelected && renderBaggagePersonalEffects()}
        {isStepTravelDelaySelected && renderStepTravelDelay()}
        {isStepMedicalAndEvacuationSelected && renderMedicalAndEvacuation()}
        {isStepChangesToYourJourneySCTISelected && renderChangesToYourJourneySCTI()}
        {isStepBaggageAndPersonalItemsSCTISelected && renderBaggageAndPersonalItemsSCTI()}
        {isStepPersonalAccidentSCTISelected && renderPersonalAccidentSCTI()}
        {isStepRentalVehicleExcessSCTISelected && renderRentalVehicleExcessSCTI()}
        {isStepCashBankCardsTravelDocumentsAndPassportsSelected && renderCashBankCardsTravelDocumentsAndPassports()}
        {isStepChangesToYourJourneySelected && renderChangesToYourJourney()}
        {isStepBaggageAndPersonalItemsStarrSelected && renderBaggageAndPersonalItemsStarr()}
        {isStepOtherStarrSelected && renderOtherStarr()}
        {isStepCollisionDamageStarrSelected && renderCollisionDamageStarr()}
        {isStepMedicalExpensesTugoSelected && renderMedicalExpensesTugo()}
        {isStepOtherTugoSelected && renderOtherTugo()}
        {isStepBaseVictorsMedicalTugoSelected && renderBaseVictorsMedicalTugo()}
        {isStepStudentMedicalBenefitsTugoSelected && renderStudentMedicalBenefitsTugo()}
        {isStepStandardVTCMedicalBenefitsTugoSelected && renderStandardVTCMedicalBenefitsTugo()}
        {isStepTripInterruptionTugoSelected && renderTripInterruptionTugo()}
        {isStepTripCancellationTugoSelected && renderTripCancellationTugo()}
        {isStepADAndDTugoSelected && renderADAndDTugo()}
      </tbody>
    </Table>
  );
};
export default DocumentTable;



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepDeclaration/components/DocumentTable/index.js